import React from 'react';

const SettingPage = () => {
    return (
        <div className="centerized-text">
            <h4>This Feature will be Added Soon</h4>
        </div>
    );
};

export default SettingPage;